import React from "react";
import webui, { BaseComponent } from "@tinqin/tinqin-web-ui";
import ResponsiveHOC from "../../HOC/components/responsive";

class ExpertInfoEventSection extends BaseComponent {
    constructor(props) {
        super(props);

        this.state = {
            isExpanded: false
        };

        this.toggleDisplay = this.toggleDisplay.bind(this);
    }

    componentDidUpdate() {
        if (this.props.size === "L") {
            if (this.state.isExpanded) return;
        } else {
            this.setState({
                isExpanded: false
            });
        }
    }

    toggleDisplay() {
        this.setState({
            isExpanded: !this.state.isExpanded
        });
    }

    render() {
        const childrenRegions = this.resolveRegions();
        const btnExpanded = this.state.isExpanded === true ? "tq-expanded" : "";
        const buttonClassName = `tq-section tq-expandable ${btnExpanded}`;
        return (
            <div>
                <div className="tq-accordion un-info-accordion">
                    <div onClick={this.toggleDisplay} className={buttonClassName}>
                        <div className="tq-section-header">
                            <div className="tq-splitbox">
                                <div className="tq-splitbox-primary">{childrenRegions.header}</div>
                            </div>
                        </div>
                        {childrenRegions.content}
                    </div>
                </div>
            </div>
        );
    }
}

export default webui.connectComponent({
    actions: { dispatchSirenActions: "siren.dispatchSirenActions" }
})(ResponsiveHOC(ExpertInfoEventSection, { sizes: { L: 0, XL: 1201 } }));
